export * from './socialmedia.component';
